import React, { useState, useContext, useEffect, useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { PolicyService } from 'gw-capability-policy';
import { MLAlertGroupComponent } from 'ml-components-common-react';
import { MLTagManagerService } from 'ml-portals-services-react';
import appConfig from 'app-config';

import metadata from './MLInspectionKeyRemindersModal.metadata.json5';
import styles from './MLInspectionKeyRemindersModal.module.scss';
import messages from './MLInspectionKeyRemindersModal.messages';

const MLInspectionKeyRemindersModal = (props) => {
    const {
        viewModelService,
        authHeader,
        onCancel,
        inspectionType
    } = props;

    const translator = useTranslator();
 
    const isExteriorOnly = inspectionType === 'Exterior-Only Onsite' || inspectionType === 'Exterior-Only Self-Survey';
    const isMidValue = inspectionType === 'Mid-Value/Modified High Value';
    const isHighValue = inspectionType === 'High Value';

    const overrideProps = {
        /* -------- Exterior Only -------- */
        exteriorOnlyIntroSection: {
            visible: isExteriorOnly
        },
        exteriorOnlyOnsiteDivider: {
            visible: isExteriorOnly
        },
        exteriorOnlyOnsiteHeader: {
            visible: isExteriorOnly
        },
        exteriorOnlyOnsiteList: {
            visible: isExteriorOnly
        },
        exteriorOnlySelfSurveyDivider: {
            visible: isExteriorOnly
        },
        exteriorOnlySelfSurveyHeader: {
            visible: isExteriorOnly
        },
        exteriorOnlySelfSurveyList: {
            visible: isExteriorOnly
        },

        /* -------- Header / Footer full-width dividers -------- */
        headerDivider: {
            className: styles.fullWidthDivider
        },
        footerDivider: {
            className: styles.fullWidthDivider
        },

        /* -------- Mid‑Value -------- */
        midValueSection: {
            visible: isMidValue
        },
      
        /* -------- High Value -------- */
        highValueSection: {
            visible: isHighValue
        }
    };
    
    const resolvers = {
        resolveComponentMap: {},
        resolveCallbackMap: {
            onClose: onCancel
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={styles}
        />
    );
};

MLInspectionKeyRemindersModal.propTypes = {
    viewModelService: PropTypes.shape({}),
    authHeader: PropTypes.string,
    onCancel: PropTypes.func,
    inspectionType: PropTypes.string
};

MLInspectionKeyRemindersModal.defaultProps = {
    viewModelService: undefined,
    authHeader: '',
    onCancel: () => {},
    inspectionType: ''
};

export default MLInspectionKeyRemindersModal;
